export enum ProcessingOptions {
    RealTime = 'realTime',
    TimeBased = 'timeBased',
}
